import Emp900ComprobantesPage from './Emp900ComprobantesPage'

export default function Emp900FacturasPage() {
  return <Emp900ComprobantesPage tipo="factura" />
}
